import TableData from './Table';

export default TableData;
